<template>
  <LoginForm />
</template>

<script setup lang="ts">
import LoginForm from '../components/auth/LoginForm.vue'
</script>
